export default (amount: number) => {
  return `${(amount / 100).toLocaleString("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })}`;
};
